import { httpPut } from '../../../../Util/http';
import { addAlert } from '../../../../MsgNotify/msgNotifyActions';

export const DAILY_REPORT_SET_EMPLOYEE_ABSENCE = 'DAILY_REPORT_SET_EMPLOYEE_ABSENCE'
export const setEmployeeHasAbsence = (employeeIndex, absenceCode) => {
    return (dispatch, getState) => {
        let currentDay = getState().dailyReportReducer.date;
        dispatch({
            type: DAILY_REPORT_SET_EMPLOYEE_ABSENCE,
            absence: {
                date: new Date(currentDay.getTime() + (24 * 60 * 60 * 1000)),
                absenceCode: absenceCode,
                hours: 0
            },
            employeeIndex
        })
    }
}


export const DAILY_REPORT_REMOVE_EMPLOYEE_ABSENCE = 'DAILY_REPORT_REMOVE_EMPLOYEE_ABSENCE'
export const removeEmployeeHasAbsence = (employeeIndex) => (
    {
        type: DAILY_REPORT_REMOVE_EMPLOYEE_ABSENCE,
        employeeIndex
    }
)


export const EMPLOYEE_BREAK = 'EMPLOYEE_BREAK'
export const updateEmployeeBreak = (employeeIndex, breakHour) => (
    {
        type: EMPLOYEE_BREAK,
        employeeIndex,
        break: breakHour
    }
)

export const DAILY_REPORT_TOGGLE_SHACK = 'DAILY_REPORT_TOGGLE_SHACK'
export const toggleShack = (employeeIndex, shack) => (
    {
        type: DAILY_REPORT_TOGGLE_SHACK,
        employeeIndex,
        shack
    }
)


export const DAILY_REPORT_SET_MILEAGE = 'DAILY_REPORT_SET_MILEAGE'
export const setMileage = (employeeIndex, mileage) => (
    {
        type: DAILY_REPORT_SET_MILEAGE,
        employeeIndex,
        mileage
    }
)



export const DAILY_REPORT_EMPLOYEE_TIME_REGISTRATION = 'DAILY_REPORT_EMPLOYEE_TIME_REGISTRATION'
export const updateEmployeeTimeRegistration = (employeeIndex, timeRegistrationIndex, typeOf, val) => (
    {
        type: DAILY_REPORT_EMPLOYEE_TIME_REGISTRATION,
        timeRegistrationIndex,
        employeeIndex,
        typeOf,
        val
    }
)


export const DAILY_REPORT_EMPLOYEE_ADD_TIME_REGISTRATION = 'DAILY_REPORT_EMPLOYEE_ADD_TIME_REGISTRATION'
export const updateEmployeeAddTimeRegistration = (employeeIndex) => (
    {
        type: DAILY_REPORT_EMPLOYEE_ADD_TIME_REGISTRATION,
        employeeIndex,
        timeRegistration: {
            employeeFunction: null,
            hours: 0,
            nightHours: 0,
            checkIn: null,
            checkOut: null,
        }
    }
)



export const DAILY_REPORT_EMPLOYEE_UPDATE_TIME_REGISTRATIONS = 'DAILY_REPORT_EMPLOYEE_UPDATE_TIME_REGISTRATIONS'
export const updateEmployeeUpdateTimeRegistrations = (employeeIndex, timeRegistrations) => (
    {
        type: DAILY_REPORT_EMPLOYEE_UPDATE_TIME_REGISTRATIONS,
        employeeIndex,
        timeRegistrations
    }
)



export const isEmployeesValid = (dispatch, getState) => {

    let employees = getState().dailyReportEmployeesReducer.employees;

    let isEmployeesValid = true;
    employees.forEach((emp) => {
        //if the activity is invalid act upon it
        emp.timeRegistrations.forEach((timeRegistration) => {
            if (timeRegistration.hours + timeRegistration.nightHours !== 0 &&
                (!timeRegistration.employeeFunction || timeRegistration.employeeFunction === "0")) {
                isEmployeesValid = false;
            }
        })

    })

    return isEmployeesValid
}


export const attemptSaveEmployees = (currentDailyReportId, getState, dispatch) => {
    let _url = process.env.REACT_APP_webApiEndPoint + 'api/dailyreport/employee/register'
    // modify url if new checkin checkout mode
    if (getState().dailyReportEmployeesReducer.checkInCheckOutMode) {
        _url = _url + 'CheckInOut'
    }

    let employees = getState().dailyReportEmployeesReducer.employees;

    let employeesToSave = filterSaveAbleEmployees(employees, dispatch);

    return httpPut(_url, { id: currentDailyReportId, employees: employeesToSave })
        .catch(() => {
            dispatch(addAlert("Kunne ikke gemme timeregistreringen"))
            throw new Error("Kunne ikke gemme timeregistreringen")
        })
}

function filterSaveAbleEmployees(employees, dispatch) {
    let result = [];
    employees.forEach((emp, index) => {
        let newEmp = { ...emp }
        let newTimeReg = [];
        emp.timeRegistrations.forEach((t) => {
            if (t.employeeFunction && t.employeeFunction !== "0")
                newTimeReg.push(t);
        })
        newEmp.timeRegistrations = newTimeReg;
        if (!newEmp.break) {
            newEmp.break = 0
        }
        result.push(newEmp);
        //update in reducer
        if (emp.timeRegistrations.length !== newTimeReg.length && newTimeReg.length !== 0) {
            dispatch(updateEmployeeUpdateTimeRegistrations(index, newEmp.timeRegistrations))
        }
    })
    return result;
}


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/DailyReport/Employees/actions.js